/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import type * as osTypes from 'os'

export default {} as typeof osTypes
